<template>
  <div class="live_status"
       v-if="Number(item.isLink) !== 1 && (item.type === 83 || item.type === 84 || item.type === 89)">
    <div class="live_status_bg1">
      <div class="nums">
        <span v-if="item.type === 89">{{ handlePV( item.pv ) }}人预约</span>
        <span v-else>{{ handlePV( item.pv ) }}人观看</span>
      </div>
    </div>
    <div class="live_status_bg2" :class="status">
      <div class="status_live" v-if="item.type === 83"></div>
      <div class="status_round" v-else></div>
      <div class="status_text">
        <span v-if="item.type === 83">直播中</span>
        <span v-if="item.type === 84">回放</span>
        <span v-if="item.type === 89">预约</span>
      </div>
      <div class="private" v-if="item.privateLive">
        <div class="private_shu"></div>
        <div class="private_icon"></div>
      </div>
    </div>
  </div>
  <div v-else-if="Number(item.isLink) === 1 && (item.type === 83 || item.type === 84 || item.type === 89)">
    <div class="link_live_status" :class="status1">
      <div class="status_live" v-if="item.type === 83"></div>
      <div class="status_round" v-else></div>
      <div class="status_text">
        <span v-if="item.type === 83">直播中</span>
        <span v-if="item.type === 84">回放</span>
        <span v-if="item.type === 89">预约</span>
      </div>
      <div class="private" v-if="item.privateLive">
        <div class="private_shu"></div>
        <div class="private_icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { handlePV } from '@/utils'

export default {
  name: 'liveStatus',
  props: [ 'item' ],
  computed: {
    status () {
      let status = 'status83'
      if ( this.item.type === 83 ) {
        status = 'status83'
      } else if ( this.item.type === 84 ) {
        status = 'status84'
      } else if ( this.item.type === 89 ) {
        status = 'status89'
      }
      return status
    },
    status1 () {
      let status = 'link_status83'
      if ( this.item.type === 83 ) {
        status = 'link_status83'
      } else if ( this.item.type === 84 ) {
        status = 'link_status84'
      } else if ( this.item.type === 89 ) {
        status = 'link_status89'
      }
      return status
    }
  },
  methods: {
    // 处理pv
    handlePV ( pv ) {
      return handlePV( pv )
    }
  }
}
</script>

<!-- 直播状态 -->
<style scoped>
.live_status {
  height: 18px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.live_status_bg1 {
  width: 89px;
  height: 18px;
  background-image: url("../../../assets/images1/card/live_status_bg1.png");
  background-size: cover;
  position: relative;
  right: -4px;
}

.nums {
  width: 88px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.live_status_bg2 {
  width: 83px;
  height: 18px;
  background-size: 83px 18px;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
  box-sizing: border-box;
}

.live_status_bg2 .private_shu {
  margin-left: 2px;
}

.status83 {
  background-image: url("../../../assets/images1/card/live_status83_bg2.png");
}

.status84 {
  background-image: url("../../../assets/images1/card/live_status84_bg2.png");
}

.status89 {
  background-image: url("../../../assets/images1/card/live_status89_bg2.png");
}

/* 外链稿件直播状态 */
.link_live_status {
  height: 20px;
  display: flex;
  align-items: center;
  padding: 0 9px 0 8px;
}

.status_live {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background-image: url("../../../assets/images1/card/zhibo.gif");
  background-size: 12px;
  background-position: 50%;
  margin-right: 2px;
}

.status_round {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  margin-right: 4px;
}

.link_status83 {
  background-color: #F33B3B;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.link_status84 {
  background-color: #67B90F;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.link_status89 {
  background-color: #0091FF;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
}

/* 外链稿件私密直播状态 */
.private {
  display: flex;
  align-items: center;
}

.status_text {
  flex-shrink: 0;
  font-size: 12px;
  line-height: 12px;
  color: #ffffff;
  position: relative;
  top: 0.5px;
}

.private_shu {
  flex-shrink: 0;
  width: 1px;
  height: 8px;
  border-radius: 0.5px;
  background-color: rgba(255, 255, 255, .8);
  margin-left: 4px;
  margin-right: 5px;
}

.private_icon {
  width: 12px;
  height: 12px;
  background-image: url("../../../assets/images1/card/suo.png");
  background-size: 12px;
  position: relative;
  top: -1px;
}
</style>